import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import Lenis from "lenis";
import collapse from "@alpinejs/collapse";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

try {
  const d = Fancybox.getDefaults();
  d.placeFocusBack = false;
  d.backFocus = false;
} catch (e) {}

const lenis = new Lenis({
  lerp: 0.2,
  wheelMultiplier: 0.8,
  infinite: false,
  gestureOrientation: "vertical",
  normalizeWheel: false,
  syncTouch: false,
  autoRaf: true,
});

window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(collapse);

Fancybox.bind("[data-fancybox]", {
  backFocus: false,
});
Fancybox.bind('[data-fancybox="images"]', {
  backFocus: false,
  on: {
    close: () => {
      // Remove focus after modal is fully closed, just before DOM cleanup
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
});
Fancybox.bind('[data-fancybox="case-blog"]', {
  backFocus: false,
  on: {
    close: () => {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
});

/// circle animation hero
document.addEventListener("alpine:init", () => {
  Alpine.data("circleInView", () => ({
    inView: false, // Track if the element is in view (near viewport center)
    visibleTexts: [], // Track visible text indices

    init() {
      const el = this.$el;
      const circle = el.querySelector(".circle-path circle");
      const textItems = el.querySelectorAll(".circle-item");

      // Calculate total height on mobile
      const isMobile = window.innerWidth < 1024; // adjust breakpoint

      if (isMobile) {
        const container = el.querySelector(".items-cont");
        if (container) {
          let totalHeight = 0;
          const textItems = container.querySelectorAll(".circle-item");
          textItems.forEach((item) => {
            const style = getComputedStyle(item);
            totalHeight +=
              item.offsetHeight +
              parseFloat(style.marginTop) +
              parseFloat(style.marginBottom);
          });
          container.style.height = totalHeight + "px";
        }
      }

      const checkInView = () => {
        const rect = el.getBoundingClientRect();
        const elemMidpoint = rect.top + rect.height / 2;
        const viewportMidpoint = window.innerHeight / 2;

        const wasInView = this.inView;
        this.inView = Math.abs(elemMidpoint - viewportMidpoint) < 350;

        if (this.inView && !wasInView) {
          circle.style.animation = "none";
          circle.offsetHeight; // trigger reflow
          circle.style.animation = "revealSwipe 5s linear forwards";

          // Only run the fade-in sequence if visibleTexts is still empty
          if (this.visibleTexts.length === 0) {
            const totalDuration = 5000; // ms
            const interval = totalDuration / textItems.length;

            textItems.forEach((item, index) => {
              setTimeout(() => {
                this.visibleTexts.push(index);
              }, interval * index);
            });
          }
        }
      };

      window.addEventListener("scroll", checkInView);
      checkInView();
    },
  }));
});

// Lees meer tooltip functionality
(() => {
  // Create the tooltip once
  const tooltip = document.createElement("div");
  tooltip.className =
    "uppercase bg-red whitespace-nowrap rounded-full text-white flex flex-row items-center w-fit px-3 py-1 font-medium tracking-wider pointer-events-none transition ease-out duration-400 opacity-0";
  tooltip.style.position = "absolute";
  tooltip.style.zIndex = "9999";
  tooltip.style.pointerEvents = "none";
  tooltip.style.transform = "scale(0.5)";
  tooltip.innerHTML = `
    Lees meer
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" version="1.1" viewBox="0 0 12 10.8" style="height:14px">
      <path fill="currentColor" d="M5.4,1h.1c0,0,0,0,0-.1h0Z"/>
      <path fill="currentColor" d="M9.8,3.9c-.5-.5-1-1.1-1.5-1.7C7.8,1.6,7.3.8,6.8,0l-1.3.9c.4.7.8,1.3,1.3,1.8.5.6,1,1,1.4,1.4.2.2.4.4.7.6-.3,0-.6,0-1,0H.8v1.6h7.1c.3,0,.6-.1.9-.1-.2.1-.4.3-.6.4-.5.4-.9.9-1.4,1.4-.4.5-.9,1.1-1.3,1.8l1.3,1c.5-.8,1-1.6,1.5-2.2.5-.6,1-1.2,1.5-1.7s1.1-1,1.7-1.5c-.6-.4-1.2-.9-1.7-1.4Z"/>
    </svg>
  `;
  document.addEventListener("DOMContentLoaded", () =>
    document.body.appendChild(tooltip),
  );

  let activeEl = null;

  // Show/hide on mouseover/mouseout using delegation "lees meer"
  document.addEventListener("mouseover", (e) => {
    const el = e.target.closest(".lees-meer");
    if (el) {
      if (activeEl !== el) {
        activeEl = el;
        tooltip.style.opacity = "1";
        tooltip.style.transform = "scale(1)";
        activeEl.style.cursor = "none";
      }
    }
  });

  document.addEventListener("mouseout", (e) => {
    if (!activeEl) return;
    const to = e.relatedTarget;
    // If moving outside the current .lees-meer entirely, hide
    if (!to || !to.closest || !to.closest(".lees-meer")) {
      tooltip.style.opacity = "0";
      tooltip.style.transform = "scale(0.5)";
      activeEl.style.cursor = "auto";
      activeEl = null;
    }
  });

  // Track mouse position only while active
  document.addEventListener("mousemove", (e) => {
    if (!activeEl) return;
    const rect = tooltip.getBoundingClientRect();
    tooltip.style.left = e.pageX - rect.width / 2 + "px";
    tooltip.style.top = e.pageY - rect.height / 2 + "px";
  });
})();
///// add svg arrow to buttons
document.addEventListener("DOMContentLoaded", () => {
  const svgArrow = `
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" version="1.1" viewBox="0 0 12 10.8" style="height:14px">
      <path fill="currentColor" d="M5.4,1h.1c0,0,0,0,0-.1h0Z"/>
      <path fill="currentColor" d="M9.8,3.9c-.5-.5-1-1.1-1.5-1.7C7.8,1.6,7.3.8,6.8,0l-1.3.9c.4.7.8,1.3,1.3,1.8.5.6,1,1,1.4,1.4.2.2.4.4.7.6-.3,0-.6,0-1,0H.8v1.6h7.1c.3,0,.6-.1.9-.1-.2.1-.4.3-.6.4-.5.4-.9.9-1.4,1.4-.4.5-.9,1.1-1.3,1.8l1.3,1c.5-.8,1-1.6,1.5-2.2.5-.6,1-1.2,1.5-1.7s1.1-1,1.7-1.5c-.6-.4-1.2-.9-1.7-1.4Z"/>
    </svg>
  `;

  document.querySelectorAll(".button:not(.noSvg)").forEach((btn) => {
    if (!btn.querySelector("svg")) {
      btn.insertAdjacentHTML("beforeend", svgArrow);
    }
  });
});

Alpine.start();

// select list icon
document.querySelectorAll("select").forEach((select) => {
  select.addEventListener("focus", () => {
    select.parentElement.classList.add("open");
  });
  select.addEventListener("blur", () => {
    select.parentElement.classList.remove("open");
  });
});

// import "./favicon.js";
import "./scrollStep.js";
import "./leaflet.js";
import "./boxSizing.js";
import "./sliders.js";
import "./animations.js";
import "./sharing.js";
import "./fixes/iubenda.js";
import "./fixes/hashAnchor.js";
